export default [
    {
        label: 'Quang Minh',
        value: 'QM'
    },
    {
        label: 'Đăng Quang',
        value: 'SW'
    }
]